@if (announcement) {
  <div
    class="announcement"
    [class.announcement--is-fixed]="announcement?.isFixed"
    #announcementRef
    >
    @if (type === 'winterHolidays') {
      <div class="snowflakes">
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
      </div>
    }
    <p class="announcement__text">{{ announcement.announcement }}</p>
  </div>
}
